import { render, staticRenderFns } from "./ai-companion-learn-more-dialog.vue?vue&type=template&id=6171851c"
import script from "./ai-companion-learn-more-dialog.vue?vue&type=script&lang=js"
export * from "./ai-companion-learn-more-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports